import React, { useEffect, useState } from "react";
import ProjectsAccordion from "../../components/Accordions/ProjectsAccordion";
import APISESSION from "../../api/ApiSession";
import ReactAutocomplete from "react-autocomplete";

const apiSession = new APISESSION();

const FactoryUser = ({
  activeUsers,
  factoryUser,
  setLoading,
  loading,
  callSnackbar,
  setFactoryUser,
  setActiveUsers,
  getFactoryUsers,
}) => {
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [userList, setUserList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalUserList, setModalUserList] = useState([]);
  const [activeSearchText, setActiveSearchText] = useState("");
  const [filteredUsers, setFilteredUsers] = useState(activeUsers);
  const [users, setUsers] = useState(activeUsers);
  const [usersSearch, setUsersSearch] = useState(activeUsers);
  const [showUserTable, setShowUserTable] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletingUser, setDeletingUser] = useState(null);

  const projectTypes = [
    "DaaS ANSI",
    "DaaS ETO",
    "DaaS IEC",
    "MGaaS ANSI",
    "MGaaS AccessToEnergy",
    "MGaaS ETO",
    "MGaaS IEC",
  ];

  const resetModal = () => {
    setOpenModal(false);
    setActiveSearchText("");
    setShowUserTable([]);
    setUsersSearch([]);
  };
  const handleAddItem = (projectType) => {
    setSelectedProjectType(projectType);
    setOpenModal(true);
    let filterSearchData = factoryUser[projectType]?.map((user) => user.userId);
    let filteredActiveUserData = [];
    activeUsers.map((userData) => {
      if (!filterSearchData?.includes(userData.value)) {
        filteredActiveUserData.push(userData);
      }
    });
    setActiveUsers([...filteredActiveUserData]);
  };

  const handleAdd = () => {
    setLoading(true);
    const payload = {
      projectType: selectedProjectType,
      userId: showUserTable.length > 0 ? showUserTable.map((a) => a.value) : [],
    };
    try {
      apiSession
        .addFactoryUsers(payload)
        .then(() => {
          getFactoryUsers();
          setOpenModal(false);
          callSnackbar("success", "Users Added successfully");
          setLoading(false);
          resetModal();
        })
        .catch((e) => {
          setLoading(false);
          resetModal();
          callSnackbar(
            "error",
            e?.response?.data?.message || "Failed to add users"
          );
        });
    } catch (error) {
      setLoading(false);
      resetModal();
      callSnackbar("error", "Failed to add users");
    }
  };

  const closeModal = () => {
    resetModal();
  };

  const handleDelete = () => {
    setLoading(true);

    try {
      apiSession
        .removeFactoryUser(deletingUser.id)
        .then(() => {
          callSnackbar("success", "User Deleted Successfully");
          getFactoryUsers();
          resetModal();
          setDeletingUser(null);
          setDeleteModal(false);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          resetModal();
          setDeletingUser(null);
          setDeleteModal(false);
          callSnackbar("error", "Error While Deleting user");
        });
    } catch (error) {
      callSnackbar("error", "Error While Deleting user");
    }
  };

  useEffect(() => {
    if (activeUsers && activeUsers.length > 0) {
      setUsersSearch(activeUsers);
    }
  }, [activeUsers]);

  const onChangeActiveSearch = (e) => {
    let eventValue = e.target.value.replace(/\s+/g, " ");
    setActiveSearchText(eventValue);

    if (eventValue.length >= 4) {
      const filteredUsers = usersSearch.filter((user) => {
        return (
          user.label.toLowerCase().indexOf(eventValue.toLowerCase()) !== -1
        );
      });
      setUsersSearch(filteredUsers);
    } else {
      if (showUserTable.length > 0) {
        const updatedUsersSearch = activeUsers.filter(
          (user) =>
            !showUserTable.some((showUser) => showUser.value === user.value)
        );
        setUsersSearch(updatedUsersSearch);
      } else {
        setUsersSearch(activeUsers);
      }
    }
  };
  const onSelectActiveSearch = (e) => {
    const user = activeUsers.find((user) => user.label === e);

    const filteredSearchData = usersSearch.filter(
      (userData) => userData.label !== e
    );
    setShowUserTable([...showUserTable, user]);
    setUsersSearch(filteredSearchData);
    setActiveSearchText("");
  };

  const handleDeleteFromModal = (userData) => {
    setUsersSearch([...usersSearch, userData]);
    const filteredUserList = showUserTable.filter(
      (user) => user.value !== userData.value
    );
    setShowUserTable(filteredUserList);
  };

  const closeDeleteModal = () => {
    setDeletingUser(null);
    setDeleteModal(false);
  };
  return (
    <>
      {
        <se-dialog
          id="dialog-complex-delete-confirm"
          open={deleteModal}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you confirm to delete selected User ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button disabled={loading} onClick={handleDelete}>
              Yes
            </se-button>
            <se-button onClick={closeDeleteModal}>No</se-button>
            <div className={loading ? "loader__center" : ""}>
              <se-loading loading={loading}></se-loading>
            </div>
          </se-dialog-footer>
        </se-dialog>
      }
      <ProjectsAccordion label="Factory Configurations">
        {projectTypes?.map((factoryProjectType, index) => {
          return (
            <ProjectsAccordion
              key={index}
              label={factoryProjectType}
              addItem
              handleAddItem={() => handleAddItem(factoryProjectType)}
            >
              {factoryUser[factoryProjectType]?.length > 0 ? (
                <table className="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th>S. No</th>
                      <th>Name</th>
                      <th>Email Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {factoryUser[factoryProjectType]?.length > 0 ? (
                    factoryUser[factoryProjectType].map((userData, key) => {
                      return (
                        <tbody>
                          <tr key={userData.userId}>
                            <td>{key + 1}</td>
                            <td>{userData.username}</td>
                            <td>{userData.email}</td>
                            <td>
                              <se-icon
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeletingUser(userData);
                                }}
                                size="small"
                                color="secondary"
                                className="se-life-green"
                              >
                                action_delete
                              </se-icon>
                            </td>
                          </tr>
                        </tbody>
                      );
                    })
                  ) : (
                    <tbody className="text-center">No Records</tbody>
                  )}
                </table>
              ) : (
                <>
                  <div className="text-center">No Items Found</div>
                </>
              )}
            </ProjectsAccordion>
          );
        })}
        <se-dialog
          id="dialog-complex-delete-confirm"
          open={openModal}
          can-backdrop="false"
        >
          <se-dialog-header>
            {"Add"} {selectedProjectType}
          </se-dialog-header>
          <se-dialog-content
            className="se-dialog-content "
            style={{ minHeight: "150px" }}
          >
            <>
              <div className="row mt-1">
                <div className="col-md-12">
                  <div className="row mt-2">
                    <div className="col-md-3 mt-2">
                      <span className="se-life-green se-font-14px-bold ">
                        Search By Users :
                      </span>
                    </div>
                    <div className="col-md-8 mt-2 my-auto">
                      <ReactAutocomplete
                        items={usersSearch}
                        // shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={(item) => item.label}
                        renderItem={(item, highlighted) => (
                          <div
                            key={item.id}
                            style={{
                              backgroundColor: highlighted
                                ? "#eee"
                                : "transparent",
                            }}
                          >
                            {item.label}
                          </div>
                        )}
                        value={activeSearchText}
                        menuStyle={{
                          borderRadius: "3px",
                          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                          background: "var(--se-background-alternative)",
                          padding: "2px 0",
                          fontSize: "14px",
                          position: "fixed",
                          overflow: "auto",
                          maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                          zIndex: "1000",
                        }}
                        wrapperProps={{
                          className: "col-sm-12",
                        }}
                        inputProps={{
                          className: "form-control",
                        }}
                        onChange={(e) => onChangeActiveSearch(e)}
                        onSelect={(value) => onSelectActiveSearch(value)}
                      />
                    </div>

                    {showUserTable.length > 0 && (
                      <div className="col-md m-0">
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>S. No</th>
                              <th>Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          {showUserTable.map((userData, key) => {
                            return (
                              <tbody>
                                <tr key={key}>
                                  <td>{key + 1}</td>
                                  <td>{userData.label}</td>
                                  <td>
                                    <se-icon
                                      onClick={() =>
                                        handleDeleteFromModal(userData)
                                      }
                                      size="small"
                                      color="secondary"
                                      className="se-life-green"
                                    >
                                      action_delete
                                    </se-icon>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          </se-dialog-content>

          <se-dialog-footer className="position-relative ">
            <div
              className="col-md ml-20 "
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <se-button onClick={closeModal}>Cancel</se-button>
              <se-button
                option="flat"
                color="primary"
                disabled={showUserTable.length === 0}
                onClick={() => handleAdd()}
              >
                Add
              </se-button>
            </div>
            <div className={loading ? "loader__center" : ""}>
              <se-loading loading={loading}></se-loading>
            </div>
          </se-dialog-footer>
        </se-dialog>
      </ProjectsAccordion>
    </>
  );
};

export default FactoryUser;
